import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

@Injectable()
export class DataService_VerifyLog {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	DriverVerifyLogSelectList(StartDate, EndDate) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/DriverVerifyLogSelectList?StartDate=" + StartDate + "&EndDate=" + EndDate;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
